import { render, staticRenderFns } from "./DocumentFinder.vue?vue&type=template&id=74b7bde8&scoped=true"
import script from "./DocumentFinder.vue?vue&type=script&lang=js"
export * from "./DocumentFinder.vue?vue&type=script&lang=js"
import style0 from "./DocumentFinder.vue?vue&type=style&index=0&id=74b7bde8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b7bde8",
  null
  
)

export default component.exports